export const appointments = [
  {
    title: 'קארטה',
    triningType: 'קארטה',
    startDate: new Date(2021, 4, 25, 9, 30),
    endDate: new Date(2021, 4, 25, 10, 30),
    id: 0,
    TrainingDetailsId: 1,
    Trainees: [1,4],
    moreInfo:''
  }, {
    title: 'קרוספיט',
    triningType: 'קרוספיט',
    startDate: new Date(2021, 4, 25, 12, 0),
    endDate: new Date(2021, 4, 25, 13, 0),
    id: 1,
    TrainingDetailsId: 2,
    Trainees: [7],
    moreInfo:''
  }, {
    title: 'ריקוד',
    triningType: 'ריקוד',
    startDate: new Date(2021, 4, 25, 14, 30),
    endDate: new Date(2021, 4, 25, 15, 30),
    id: 2,
    TrainingDetailsId: 4,
    Trainees: [1,3,6],
    moreInfo:''
  }, {
    title: 'ריקוד',
    triningType: 'ריקוד',
    startDate: new Date(2021, 4, 26, 10, 0),
    endDate: new Date(2021, 4, 26, 11, 0),
    id: 3,
    TrainingDetailsId: 6,
    Trainees: [2,4,6],
    moreInfo:''
  }, {
    title: 'קארטה',
    triningType: 'קארטה',
    startDate: new Date(2021, 4, 26, 12, 0),
    endDate: new Date(2021, 4, 26, 13, 30),
    id: 4,
    TrainingDetailsId: 4,
    Trainees: [2,3,7],
    moreInfo:''
  },  {
    title: 'קארטה',
    triningType: 'קארטה',
    startDate: new Date(2021, 4, 27, 9, 30),
    endDate: new Date(2021, 4, 27, 10, 30),
    id: 6,
    TrainingDetailsId: 2,
    Trainees: [2],
    moreInfo:''
  }, {
    title: 'ריצה',
    triningType: 'ריצה',
    startDate: new Date(2021, 4, 27, 12, 0),
    endDate: new Date(2021, 4, 27, 14, 0),
    id: 7,
    TrainingDetailsId: 1,
    Trainees: [7],
    moreInfo:''
  }, {
    title: 'ריצה',
    triningType: 'ריצה',
    startDate: new Date(2021, 4, 27, 15, 15),
    endDate: new Date(2021, 4, 27, 16, 30),
    id: 8,
    TrainingDetailsId: 4,
    Trainees: [1,3,5],
    moreInfo:''
  }, {
    title: 'שחייה',
    triningType: 'שחייה',
  startDate: new Date(2021, 4, 23, 10, 30),
  endDate: new Date(2021, 4, 23, 11, 30),
  id: 9,
  TrainingDetailsId: 3,
  Trainees: [1,3,6,7],
  moreInfo:''
}, {
  title: 'שחייה',
  triningType: 'שחייה',
  startDate: new Date(2021, 4, 23, 13, 0),
  endDate: new Date(2021, 4, 23, 14, 0),
  id: 10,
  TrainingDetailsId: 5,
  Trainees: [1,2,5],
  moreInfo:''
},
{
  title: 'שחייה',
  triningType: 'שחייה',
  startDate: new Date(2021, 4, 24, 12, 0),
  endDate: new Date(2021, 4, 24, 13, 30),
  id: 11,
  TrainingDetailsId: 4,
  Trainees: [1,2,4,6,7],
  moreInfo:''
}, 
];